import React, { useEffect, useState } from "react";
import API, { BASE_URL } from "../api/Api";
import { Link } from "react-router-dom";

export default function JoinWithUs() {
  const [joinData, setJoinData] = useState([]);

  // 🔹 Fetch Join With Us data
  useEffect(() => {
    API.get("/join_with_us")
      .then((res) => {
        const data = res.data.data || [];
        setJoinData(data);
      })
      .catch((err) => {
        console.error("Join With Us API Error", err);
      });
  }, []);

  return (
    <section className="ucsr-join-section">
      <div className="container text-center mb-5">
        <h2 className="ucsr-join-title">Join with Us</h2>
        <p className="ucsr-join-subtitle">
          Become a part of India's largest CSR ecosystem
        </p>
      </div>

      <div className="container">
        <div className="row g-4">

          {joinData.map((item, index) => (
            <div className="col-lg-4" key={index}>
              <div className="ucsr-join-card">

                {/* 🔹 ICON → IMAGE */}
                <div className="ucsr-join-icon ucsr-icon-purple">
                  <img
                    src={`${BASE_URL}/assets/images/${item.image}`}
                    alt={item.title}
                    className="ucsr-join-img"
                  />
                </div>

                <h4>{item.title}</h4>
                <p>{item.description}</p>

                <Link to="/registration" className="ucsr-join-btn">
                  {item.button_name}{" "}
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>

              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}
